export const categories = [
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line', description: '全网最热内容，每日更新精选推荐' },
  { slug: 'new', name: '最新上架', icon: 'ri-sparkling-line', description: '第一时间获取最新资源' },
  { slug: 'classic', name: '经典回顾', icon: 'ri-vip-crown-line', description: '经典永不过时，重温美好时光' },
  { slug: 'hd', name: '高清专区', icon: 'ri-4k-line', description: '超高清画质，极致观影体验' },
  { slug: 'anime', name: '动漫精选', icon: 'ri-movie-line', description: '热门动漫一网打尽' },
  { slug: 'variety', name: '综艺娱乐', icon: 'ri-emotion-laugh-line', description: '轻松一刻，欢乐无限' },
];

export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的十部大作盘点',
    slug: '2024-top-10-movies',
    category: 'hot',
    description: '盘点今年最受期待的影视大作，从动作大片到文艺佳作，总有一部适合你。',
    content: `## 2024年最值得期待的十部大作盘点

2024年注定是影视行业的丰收年，众多备受期待的大作将在今年陆续与观众见面。撸撸社为您精心整理了今年最值得关注的十部作品。

### 1. 动作冒险类

今年动作片市场异常火爆，多部投资过亿的大制作将在暑期档集中上映。这些作品不仅在视觉效果上做到了极致，故事情节也更加丰满。

### 2. 文艺佳作

除了商业大片，今年的文艺片市场同样精彩。多位国际知名导演带来了他们的新作，探讨人性、社会和时代的深刻主题。

### 3. 动画电影

动画电影方面，今年也有多部值得期待的作品。无论是日本动漫还是国产动画，都在技术和叙事上有了长足进步。

---

撸撸社将持续为您追踪这些作品的最新动态，第一时间提供高清资源，敬请关注！`,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20collage%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20film%20reel%20texture%20overlay%2C%20dark%20theater%20background%2C%20artistic%20composition%2C%20high%20contrast%20cinematography%20style&width=800&height=450&seq=article-1&orientation=landscape',
    date: '2024-01-15',
    views: 12888,
    tags: ['电影', '盘点', '2024'],
  },
  {
    id: 2,
    title: '会员专属福利全面升级，尊享八大权益',
    slug: 'member-benefits-upgrade',
    category: 'hot',
    description: '撸撸社会员体系全面升级，八大专属权益让您畅享极致观影体验。',
    content: `## 会员专属福利全面升级

撸撸社始终致力于为用户提供最优质的观影体验。近日，我们的会员体系迎来了全面升级，八大专属权益让每一位会员都能享受到更尊贵的服务。

### 八大核心权益

1. **高清无限制** - 所有资源均可享受最高画质
2. **极速播放** - 专属带宽通道，告别缓冲等待
3. **抢先观看** - 热门内容提前解锁
4. **去广告体验** - 纯净观影，零打扰
5. **多设备同步** - 手机、平板、电脑无缝切换
6. **专属客服** - 7×24小时优先响应
7. **会员标识** - 尊贵身份，与众不同
8. **积分翻倍** - 签到积分双倍累计

立即注册成为撸撸社会员，享受全新升级的尊享服务！`,
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20VIP%20membership%20theme%20with%20golden%20accents%20on%20dark%20background%2C%20elegant%20geometric%20patterns%2C%20premium%20lifestyle%20aesthetic%2C%20warm%20golden%20and%20deep%20charcoal%20tones%2C%20sophisticated%20minimalist%20design&width=800&height=450&seq=article-2&orientation=landscape',
    date: '2024-01-10',
    views: 9656,
    tags: ['会员', '福利', '升级'],
  },
  {
    id: 3,
    title: '新番推荐：《星空物语》深度评测',
    slug: 'starry-tale-review',
    category: 'anime',
    description: '年度最受期待的日本动漫新番终于来了！撸撸社为您带来第一手深度评测。',
    content: `## 新番推荐：《星空物语》深度评测

本季最受关注的日本动漫新番《星空物语》已于近日正式上线。作为制作团队耗时三年打造的诚意之作，这部作品从第一集就展现出了极高的制作水准。

### 画面表现

画面质量堪称业界顶尖，每一帧都可以截图当壁纸。背景美术细腻入微，人物动作流畅自然。特别是在星空场景的呈现上，制作组显然投入了大量心血。

### 音乐配乐

由知名作曲家操刀的配乐恰到好处地烘托了剧情氛围，OP和ED也都具有极高的传唱度。

### 剧情评价

故事以星空观测为线索，讲述了少年少女们在追寻梦想过程中发生的温馨故事。节奏把控得当，既有轻松愉快的日常，也有感人至深的高潮。

---

撸撸社已上线该作品全集高清资源，欢迎各位动漫爱好者前来观看！`,
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20style%20illustration%20of%20starry%20night%20sky%20with%20silhouettes%20of%20characters%2C%20soft%20blue%20and%20purple%20gradient%2C%20dreamy%20atmosphere%2C%20twinkling%20stars%2C%20Japanese%20animation%20aesthetic&width=800&height=450&seq=article-3&orientation=landscape',
    date: '2024-01-08',
    views: 7543,
    tags: ['动漫', '新番', '评测'],
  },
  {
    id: 4,
    title: '经典重温：《时光倒流二十年》影评',
    slug: 'time-rewind-review',
    category: 'classic',
    description: '二十年前的经典之作，如今看来依然令人感动。撸撸社带您重温这部不朽的影片。',
    content: `## 经典重温：《时光倒流二十年》影评

有些电影，无论过去多少年，再次观看依然能触动心灵深处最柔软的地方。《时光倒流二十年》就是这样一部作品。

### 剧情梗概

影片讲述了一个关于时间、记忆与爱的故事。主角通过一本老日记，重新体验了二十年前那段刻骨铭心的初恋。导演用细腻的镜头语言，将过去与现在交织在一起，营造出独特的情感张力。

### 艺术价值

该片在当年获得了包括最佳影片在内的多项大奖，其对时间叙事的创新处理方式至今仍被众多电影人学习和借鉴。

### 重温感悟

二十年后再看这部作品，感受又有所不同。年轻时看到的是爱情，现在看到的是人生。

---

撸撸社经典回顾专区已上线该影片4K修复版，画质全面提升，配以中文字幕，欢迎重温经典。`,
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20vintage%20film%20aesthetic%20with%20warm%20sepia%20tones%2C%20old%20film%20camera%20on%20wooden%20desk%2C%20scattered%20photographs%2C%20soft%20sunlight%20through%20window%2C%20cinematic%20composition&width=800&height=450&seq=article-4&orientation=landscape',
    date: '2024-01-05',
    views: 6321,
    tags: ['经典', '影评', '重温'],
  },
  {
    id: 5,
    title: '4K画质对比：高清专区观影体验全面解析',
    slug: '4k-quality-comparison',
    category: 'hd',
    description: '4K到底强在哪里？撸撸社带你全面了解超高清观影的震撼体验。',
    content: `## 4K画质对比：高清专区观影体验全面解析

随着显示技术的不断进步，4K超高清已经逐渐成为主流观影标准。撸撸社高清专区全面升级4K资源，让每一位用户都能享受到极致的视觉盛宴。

### 什么是4K？

4K分辨率是指水平方向约4000像素的分辨率标准，通常是3840×2160像素，是传统1080P的四倍。这意味着更丰富的细节、更锐利的画面和更真实的色彩。

### 4K vs 1080P

在实际观影中，4K带来的提升是全方位的：
- **细节呈现**：人物面部纹理、服装质感都更加清晰
- **色彩表现**：支持HDR的4K内容拥有更宽广的色域
- **动态范围**：亮部不会过曝，暗部细节保留更好

### 撸撸社4K专区

撸撸社高清专区已全面升级为4K画质，配合专属带宽优化，确保流畅播放。会员用户可享受全部4K资源的无限观看权限。

立即升级会员，体验4K超高清的震撼世界！`,
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20home%20theater%20setup%20with%20large%204K%20screen%20displaying%20vibrant%20nature%20scene%2C%20ambient%20warm%20lighting%2C%20luxurious%20interior%2C%20high%20contrast%20cinematic%20quality&width=800&height=450&seq=article-5&orientation=landscape',
    date: '2024-01-03',
    views: 8901,
    tags: ['4K', '画质', '技术'],
  },
  {
    id: 6,
    title: '爆笑综艺盘点：今年最值得追的十档节目',
    slug: 'variety-show-ranking',
    category: 'variety',
    description: '综艺荒？不存在的！撸撸社为你精挑细选今年最值得追的十档综艺节目。',
    content: `## 爆笑综艺盘点：今年最值得追的十档节目

综艺节目已经成为我们日常生活中不可或缺的娱乐方式。撸撸社为您整理了今年最火爆的十档综艺节目，保证让您笑到停不下来。

### 1. 《欢乐大本营》新一季

作为国内最长寿的综艺节目之一，新一季的《欢乐大本营》在嘉宾阵容和游戏环节上都做了全新升级。

### 2. 《舞动奇迹》

舞蹈竞技类节目的天花板，参赛选手水平逐年提高，舞台效果也越来越震撼。

### 3. 《美食大冒险》

将美食与旅行结合的真人秀，让观众在享受视觉盛宴的同时也能收获美食灵感。

---

撸撸社综艺娱乐专区已上线以上全部节目的高清版本，每周持续更新，欢迎订阅追更！`,
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20TV%20variety%20show%20stage%20with%20colorful%20lighting%20and%20confetti%2C%20energetic%20atmosphere%2C%20bright%20warm%20colors%2C%20entertainment%20studio%20setting%2C%20dynamic%20composition&width=800&height=450&seq=article-6&orientation=landscape',
    date: '2024-01-01',
    views: 10567,
    tags: ['综艺', '盘点', '娱乐'],
  },
  {
    id: 7,
    title: '新手上路：撸撸社使用完全指南',
    slug: 'new-user-guide',
    category: 'new',
    description: '刚来撸撸社不知道怎么用？这份完全指南帮你快速上手。',
    content: `## 新手上路：撸撸社使用完全指南

欢迎加入撸撸社大家庭！无论您是第一次访问还是刚刚注册，这份指南将帮助您快速了解平台的所有功能。

### 注册与登录

1. 点击右上角"注册"按钮
2. 输入您的手机号或邮箱
3. 设置密码并完成验证
4. 注册成功后即可登录

### 浏览与搜索

撸撸社提供多种内容发现方式：
- **分类浏览**：按内容类型快速定位
- **关键词搜索**：精准找到想看的内容
- **热门推荐**：首页展示当前最受欢迎的资源

### 会员权益

升级会员后，您将享受高清画质、极速播放、去广告等多项专属服务。

---

如有任何疑问，欢迎联系我们的24小时在线客服！`,
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20onboarding%20welcome%20screen%20with%20friendly%20illustration%20style%2C%20soft%20warm%20gradient%20background%2C%20simple%20icons%2C%20user%20friendly%20interface%20concept%2C%20minimalist%20design&width=800&height=450&seq=article-7&orientation=landscape',
    date: '2023-12-28',
    views: 4567,
    tags: ['指南', '新手', '教程'],
  },
  {
    id: 8,
    title: '年度人气排行榜：最受欢迎内容TOP20',
    slug: 'annual-ranking-top20',
    category: 'hot',
    description: '撸撸社年度人气排行榜出炉！看看过去一年最受欢迎的内容有哪些。',
    content: `## 年度人气排行榜：最受欢迎内容TOP20

又到了年终盘点的时刻！撸撸社根据全年播放量、用户评分和互动数据，综合评选出了年度最受欢迎内容TOP20。

### TOP 1-5

前五名作品涵盖了动作、科幻、动画等多个类型，充分体现了撸撸社用户多元化的观影口味。

### TOP 6-10

第六到第十名的作品同样精彩纷呈，其中不乏一些口碑逆袭的黑马之作。

### 完整榜单

完整TOP20榜单已在撸撸社首页热门推荐区上线，快去查看你喜欢的作品排在第几名吧！

---

新的一年，撸撸社将继续为您带来更多优质内容，敬请期待！`,
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20ranking%20list%20design%20with%20golden%20trophy%20and%20medals%2C%20dark%20elegant%20background%2C%20spotlight%20effect%2C%20award%20ceremony%20theme%2C%20premium%20cinematic%20style&width=800&height=450&seq=article-8&orientation=landscape',
    date: '2023-12-25',
    views: 15234,
    tags: ['排行', '年度', '热门'],
  },
  {
    id: 9,
    title: '经典动漫《暗夜传说》全系列回顾',
    slug: 'dark-legend-review',
    category: 'anime',
    description: '跨越十年的经典动漫系列，撸撸社带你回顾《暗夜传说》的每一个精彩瞬间。',
    content: `## 经典动漫《暗夜传说》全系列回顾

《暗夜传说》系列从第一部至今已经走过了整整十年。这部作品不仅在日本国内引起了巨大反响，在全球范围内也积累了庞大的粉丝群体。

### 系列发展历程

从第一季的青涩到最新季的成熟，整个系列在制作质量和叙事深度上都实现了质的飞跃。每一季都有独特的主题和风格，但又保持了系列一贯的高水准。

### 角色解析

丰富的角色塑造是《暗夜传说》成功的关键之一。每一个角色都有着立体的性格和感人的成长故事，让观众产生强烈的共鸣。

### 经典场面

系列中诞生了无数令人难忘的经典场面，每一个都值得反复回味。

---

撸撸社动漫精选专区已上线《暗夜传说》全系列高清资源，包含剧场版和OVA，欢迎补番！`,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20anime%20scene%20with%20dark%20fantasy%20theme%2C%20moonlit%20castle%20silhouette%2C%20mysterious%20atmosphere%2C%20deep%20blue%20and%20silver%20color%20palette%2C%20epic%20cinematic%20composition&width=800&height=450&seq=article-9&orientation=landscape',
    date: '2023-12-20',
    views: 8234,
    tags: ['动漫', '经典', '回顾'],
  },
  {
    id: 10,
    title: '假期观影指南：春节宅家必看清单',
    slug: 'holiday-watch-guide',
    category: 'hot',
    description: '春节假期不知道看什么？撸撸社为你准备了一份超详细的宅家观影清单。',
    content: `## 假期观影指南：春节宅家必看清单

春节假期即将到来，与其外出人挤人，不如宅在家里享受一场视听盛宴。撸撸社为您精心准备了一份假期观影清单。

### 合家欢推荐

适合全家人一起观看的温馨喜剧和动画电影，欢声笑语中感受浓浓年味。

### 热血动作

假期也需要一些激情！精选动作大片让您在家也能感受大银幕的震撼。

### 烧脑悬疑

喜欢动脑筋的影迷不要错过这些烧脑佳作，每一部都能让您沉浸其中，忘记时间的流逝。

---

撸撸社春节不打烊，所有资源正常更新。祝大家新年快乐，观影愉快！`,
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20scene%20with%20TV%20screen%2C%20Chinese%20New%20Year%20decorations%2C%20red%20lanterns%2C%20warm%20festive%20atmosphere%2C%20comfortable%20home%20cinema%20setup&width=800&height=450&seq=article-10&orientation=landscape',
    date: '2023-12-18',
    views: 11234,
    tags: ['假期', '清单', '春节'],
  },
];

export const faqs = [
  {
    question: '如何注册撸撸社会员？',
    answer: '点击页面右上角的"注册"按钮，输入手机号或邮箱地址，设置密码并完成验证即可完成注册。整个过程只需1分钟。',
  },
  {
    question: '会员有哪些专属权益？',
    answer: '会员可享受高清无限制播放、极速带宽通道、去广告体验、多设备同步观看、7×24小时专属客服、抢先观看热门内容、尊贵会员标识以及积分双倍累计等八大核心权益。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '撸撸社支持全平台观看，包括电脑端（Windows/Mac）、移动端（iOS/Android）、平板以及智能电视。一个账号可在多台设备上使用。',
  },
  {
    question: '如何找到我想看的内容？',
    answer: '您可以通过首页的分类导航浏览不同类别的内容，也可以使用顶部的搜索框输入关键词进行精准搜索。此外，首页的热门推荐区会展示当前最受欢迎的资源。',
  },
  {
    question: '播放卡顿怎么办？',
    answer: '如果您遇到播放卡顿的情况，可以尝试以下方法：1）切换播放清晰度；2）检查网络连接；3）清除浏览器缓存；4）升级为会员享受专属带宽。如问题仍未解决，请联系在线客服。',
  },
  {
    question: '如何联系客服？',
    answer: '撸撸社提供7×24小时全天候客服支持。您可以通过在线客服聊天窗口、官方邮箱service@lulushe.com或客服热线400-XXX-XXXX联系我们。会员用户享受优先响应服务。',
  },
];

export const reputations = [
  {
    name: '张先生',
    role: '资深会员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20male%20portrait%20avatar%2C%20simple%20warm%20background%2C%20friendly%20expression%2C%20clean%20minimalist%20style&width=100&height=100&seq=avatar-1&orientation=squarish',
    content: '使用撸撸社三年了，资源更新速度真的快，画质也没得说。会员价格合理，性价比超高！',
    rating: 5,
  },
  {
    name: '李女士',
    role: '白金会员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20female%20portrait%20avatar%2C%20simple%20warm%20background%2C%20confident%20smile%2C%20clean%20minimalist%20style&width=100&height=100&seq=avatar-2&orientation=squarish',
    content: '最喜欢撸撸社的动漫专区，更新速度和画质都是一流的。客服服务态度也特别好，有问题随时能解决。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '年度会员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20student%20portrait%20avatar%2C%20simple%20warm%20background%2C%20friendly%20casual%20style%2C%20clean%20minimalist&width=100&height=100&seq=avatar-3&orientation=squarish',
    content: '作为动漫爱好者，撸撸社的资源库真的太全了。很多冷门番都能找到，而且都是高清版本。强烈推荐！',
    rating: 5,
  },
  {
    name: '刘先生',
    role: '钻石会员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20mature%20Chinese%20male%20portrait%20avatar%2C%20simple%20warm%20background%2C%20professional%20look%2C%20clean%20minimalist%20style&width=100&height=100&seq=avatar-4&orientation=squarish',
    content: '从平台创立初期就在用了，见证了撸撸社一步步的成长。现在的体验真的是越来越好，会一直支持下去！',
    rating: 5,
  },
];

export const stats = [
  { label: '注册用户', value: '500万+' },
  { label: '内容资源', value: '10万+' },
  { label: '日均播放', value: '300万+' },
  { label: '用户好评率', value: '99.2%' },
];

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '正版保障',
    description: '所有内容均经过正版授权，让您安心观看，无需担心版权风险。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    description: '全球CDN加速，秒级加载，告别缓冲等待，流畅观影体验。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '支持4K超高清画质，HDR色彩增强，细节纤毫毕现。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '7×24小时在线客服，随时为您解决使用中遇到的任何问题。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持手机、平板、电脑、电视全平台，无缝切换继续观看。',
  },
  {
    icon: 'ri-lock-line',
    title: '安全加密',
    description: '银行级数据加密技术，保护您的账号安全和隐私信息。',
  },
];

export const memberBenefits = [
  { icon: 'ri-vip-crown-line', title: '高清无限制', desc: '所有资源最高画质' },
  { icon: 'ri-flashlight-line', title: '极速播放', desc: '专属带宽不卡顿' },
  { icon: 'ri-timer-flash-line', title: '抢先观看', desc: '热门内容提前解锁' },
  { icon: 'ri-forbid-2-line', title: '去广告', desc: '纯净观影零打扰' },
  { icon: 'ri-device-line', title: '多设备同步', desc: '全平台无缝切换' },
  { icon: 'ri-headphone-line', title: '专属客服', desc: '优先响应通道' },
  { icon: 'ri-medal-line', title: '会员标识', desc: '尊贵身份象征' },
  { icon: 'ri-double-quotes-l', title: '积分翻倍', desc: '签到积分双倍' },
];